import { FC } from 'react';
import { useField } from 'informed';
import { InformedFieldState } from '@common/interfaces';
import Switcher from '../Switcher';
import css from './styles.module.scss';

interface ISwitcherField {
  name: string;
  activeText?: string;
  inactiveText?: string;
  disabled?: boolean;
}

const SwitcherField: FC<ISwitcherField> = ({ name, activeText, inactiveText, disabled }) => {
  const { fieldApi, fieldState, render } = useField({ name });

  const { value, error, showError } = fieldState as InformedFieldState<boolean>;
  const { setValue, setTouched } = fieldApi;

  const isActive = !!value;

  return render(
    <div className={css.field}>
      <Switcher
        checked={isActive}
        disabled={disabled}
        hideTexts
        onChange={(checked) => {
          setValue(checked);
          setTouched(true);
        }}
      />
      <div className={css.value}>{isActive ? activeText : inactiveText}</div>
      {showError ? <div className={css.error}>{error}</div> : null}
    </div>
  );
};

export default SwitcherField;
